import { Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { getItem } from '../utils/localStorage';

const PrivateRoute = ({ element }) => {
    const isLogin = useSelector((state) => state.auth.isLogin);
    const hasToken = !!getItem('access_token');

    // Cho phép vào nếu đã login hoặc có token
    if (!isLogin && !hasToken) {
        return <Navigate to="/login" replace />;
    }

    return element;
};

export default PrivateRoute;
